import { useMemo } from 'react';
import { useBundledPlugins, useMarketplacePlugins, useTbePlugins } from '@common/queries/plugins';
import { useFeatureFlag } from '@common/server-config-context/server-config-context';
export function usePluginData(pluginIds, enabled) {
    const { data: bundledPlugins, isFetching: isBundledPluginsFetching, isLoading: isBundledPluginsLoading } = useBundledPlugins(enabled);
    const allowDenyPluginsListEnabled = useFeatureFlag('allowDenyPluginsListEnabled');
    const bundledPluginsMap = useMemo(() => new Map(bundledPlugins === null || bundledPlugins === void 0 ? void 0 : bundledPlugins.map(plugin => [
        plugin.key,
        allowDenyPluginsListEnabled ? plugin : { ...plugin, source: 'MARKETPLACE' }
    ])), [bundledPlugins, allowDenyPluginsListEnabled]);
    const { data: internalRepoPlugins, isFetching: isInternalRepoPluginsFetching, isLoading: isInternalRepoPluginsLoading } = useTbePlugins(enabled);
    const internalRepoPluginsMap = useMemo(() => new Map(internalRepoPlugins === null || internalRepoPlugins === void 0 ? void 0 : internalRepoPlugins.map(plugin => [plugin.key, plugin])), [internalRepoPlugins]);
    const { data: marketplacePlugins, isFetching: isMarketplacePluginsFetching, isLoading: isMarketplacePluginsLoading } = useMarketplacePlugins(pluginIds, enabled);
    const marketplacePluginsMap = useMemo(() => new Map(marketplacePlugins === null || marketplacePlugins === void 0 ? void 0 : marketplacePlugins.map(plugin => [plugin.key, plugin])), [marketplacePlugins]);
    const pluginsData = pluginIds.reduce((acc, pluginId) => {
        if (bundledPluginsMap.has(pluginId)) {
            return acc.set(pluginId, bundledPluginsMap.get(pluginId));
        }
        if (internalRepoPluginsMap.has(pluginId)) {
            return acc.set(pluginId, internalRepoPluginsMap.get(pluginId));
        }
        if (marketplacePluginsMap.has(pluginId)) {
            return acc.set(pluginId, marketplacePluginsMap.get(pluginId));
        }
        // custom plugin, i.e. just plugin id entered by user
        return acc.set(pluginId, undefined);
    }, new Map());
    return {
        isFetching: isBundledPluginsFetching || isInternalRepoPluginsFetching || isMarketplacePluginsFetching,
        isLoading: isBundledPluginsLoading || isInternalRepoPluginsLoading || isMarketplacePluginsLoading,
        data: pluginsData
    };
}
